module.exports = __webpack_public_path__ + "static/img/home_zs.fcda7f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/home_zs.png
// module id = XPIg
// module chunks = 137